import React, { forwardRef } from 'react';
import { LoaderCircle } from 'lucide-react';
import { cx } from './cx';

export type AdminButtonVariant =
  | 'primary'
  | 'soft'
  | 'outline'
  | 'fill'
  | 'success'
  | 'danger'
  | 'danger-soft'
  | 'ca'
  | 'link';
export type AdminButtonSize = 40 | 36 | 32;

export interface AdminButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant?: AdminButtonVariant;
  size?: AdminButtonSize;
  /** icon lucide đặt trước chữ (18px ở cỡ 40/36, 14–16px ở cỡ 32) */
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  /** bóng xanh dưới nút chính lớn ở đầu trang */
  elevated?: boolean;
  block?: boolean;
  loading?: boolean;
  /** nút chỉ có icon: tròn, cần aria-label */
  iconOnly?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

// Nút viên thuốc của admin. Mỗi khối chỉ một nút primary; các nút khác soft/outline/fill.
export const AdminButton = forwardRef<HTMLButtonElement, AdminButtonProps>(
  (
    {
      variant = 'primary',
      size = 40,
      icon,
      iconRight,
      elevated,
      block,
      loading,
      iconOnly,
      type = 'button',
      className,
      disabled,
      children,
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cx(
        'adm-btn',
        `adm-btn--${variant}`,
        `adm-btn--${size}`,
        elevated && 'adm-btn--elevated',
        block && 'adm-btn--block',
        iconOnly && 'adm-btn--icon-only',
        className
      )}
      {...rest}
    >
      {loading ? <LoaderCircle size={size === 32 ? 14 : 18} className="adm-btn__spin" aria-hidden="true" /> : icon}
      {children}
      {iconRight}
    </button>
  )
);
AdminButton.displayName = 'AdminButton';

export default AdminButton;
